import { render, staticRenderFns } from "./CompleteRegister.vue?vue&type=template&id=1b7ae901&scoped=true&"
import script from "./CompleteRegister.vue?vue&type=script&lang=js&"
export * from "./CompleteRegister.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/content.scss?vue&type=style&index=0&id=1b7ae901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ae901",
  null
  
)

export default component.exports